// extracted by mini-css-extract-plugin
module.exports = {"title_card":"TitleCard_title_card__njgZK","title":"TitleCard_title__U8Us3","title_desc":"TitleCard_title_desc__SH_D1"};